import { enStandard } from './resources/enStandard'

// Types derived from the bundled base — NO codegen. Because keys are semantic and
// language-independent, these types are stable across every language/variant: adding
// a locale never changes them.

/** All namespaces (i18next `ns`). */
export type Namespace = keyof typeof enStandard

export const NAMESPACES = Object.keys(enStandard) as Namespace[]

// i18next plural keys are stored with CLDR suffixes (`_one`, `_other`, …) but are
// addressed by their BASE key + `{ count }`. Strip the suffix so the typed key is
// `dose_count`, not `dose_count_one`.
type PluralSuffix = 'zero' | 'one' | 'two' | 'few' | 'many' | 'other'
type StripPlural<K extends string> = K extends `${infer Base}_${PluralSuffix}` ? Base : K

/** Valid semantic term keys for a namespace — typos fail at compile time. */
export type TermKey<N extends Namespace> = StripPlural<keyof (typeof enStandard)[N] & string>
